import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, Paper, TextField, Checkbox, FormControlLabel } from "@mui/material";
import { backendRoot } from "../config"; // Make sure this points to your backend
import mapImg from "../assets/New_Map.png";
import idLogo from "../assets/IntelliDropLogo.png";
import skyoviLogo from "../assets/Skyovi_logo.png";
// import idpLogo from "../assets/generated-image.png";
// import { useMsal } from "@azure/msal-react";
// const LoginWithSSO = () => {
//   const { instance } = useMsal();
//   const navigate = useNavigate();
//   const handleLogin = () => {
//     instance.loginRedirect().catch((error) => {
//     if (error.errorCode === "user_cancelled") {
//       console.warn("Login cancelled by the user.");
//     } else {
//       console.error("SSO Login failed", error);
//     }
//   });
//   };

// const handleLogout = () => {
//   instance
//     .logoutPopup()
//     .then(() => {
//       navigate("/");
//     })
//     .catch((error) => {
//       console.error("Logout failed", error);
//     });
// };

//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh", background: "#faf9f6" }}>
//       {/* Left Side - Image */}
//       <Box
//         sx={{
//           flex: 1,
//           backgroundImage: `url(${mapImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           display: { xs: "none", md: "block" },
//         }}
//       />
//       {/* Right Side - Login */}
//       <Box
//         sx={{
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           bgcolor: "#fff",
//           px: 4,
//         }}
//       >
//         <Paper
//           elevation={0}
//           sx={{
//             width: "100%",
//             maxWidth: 500,
//             p: 6,
//             boxShadow: "none",
//             bgcolor: "transparent",
//           }}
//         >
//           {/* Brightspeed Logo */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               mb: 1,
//             }}
//           >
//             <Box
//               component="img"
//               src={logoImg}
//               alt="brightspeed"
//               sx={{ height: 80 }}
//             />
//           </Box>
//           {/* TDP Logo */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               mb: 1,
//             }}
//           >
//             <Box component="img" src={tdpLogo} alt="tdp" sx={{ height: 60 }} />
//           </Box>
//           <Typography
//             variant="h4"
//             align="center"
//             sx={{ fontWeight: 700, mb: 1 }}
//           >
//             IntelliDrop
//           </Typography>

//           <Button
//             type="button"
//             variant="contained"
//             fullWidth
//             sx={{
//               background: "#FFD600",
//               color: "#222",
//               fontWeight: 600,
//               fontSize: "1.1rem",
//               mb: 6,
//               "&:hover": { background: "#FFC400" },
//               borderRadius: 1,
//               py: 1.8,
//             }}
//             onClick={handleLogin}
//           >
//             Login with SSO
//           </Button>
//           <Typography variant="body2" color="text.secondary" align="center">
//             Copyright © 2025 | Brightspeed
//           </Typography>
//         </Paper>
//       </Box>
//     </Box>
//   );
// };

function Login() {
  const [email, setEmail] = useState("admin@intellidrop.ai");
  const [password, setPassword] = useState("TzHvCVj8J8");
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const passwordRef = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Trigger entrance transitions after initial render
    const t = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(t);
  }, []);

  // Load saved credentials if Remember Me was enabled previously
  useEffect(() => {
    const saved = localStorage.getItem('rememberMe') === 'true';
    const savedEmail = localStorage.getItem('savedEmail');
    const savedPassword = localStorage.getItem('savedPassword');
    if (saved) {
      setRememberMe(true);
      if (savedEmail) setEmail(savedEmail);
      if (savedPassword) setPassword(savedPassword);
    }
  }, []);

  // 1️⃣ Handle the form submission (Enter on password or click)
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Save or clear credentials based on Remember Me
    if (rememberMe) {
      localStorage.setItem('rememberMe', 'true');
      localStorage.setItem('savedEmail', email);
      localStorage.setItem('savedPassword', password);
    } else {
      localStorage.removeItem('rememberMe');
      localStorage.removeItem('savedEmail');
      localStorage.removeItem('savedPassword');
    }

    // Direct navigation to app selector page without authentication
    navigate("/app-selector");

    // Commented out the original authentication logic
    /*
    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    setError("");
    try {
      const res = await fetch(`${backendRoot}/processter/token/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (res.ok) {
        localStorage.setItem(
          "authTokens",
          JSON.stringify({ access: data.access, refresh: data.refresh })
        );
        localStorage.setItem("userDetail", JSON.stringify(data));
        navigate("/transactions");
      } else if (res.status === 401) {
        setError("Password is incorrect");
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Login failed. Please try again.");
    }
    */
  };
  const onEmailKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // don’t submit yet
      passwordRef.current?.focus(); // send focus to password
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", background: "#fff" }}>
      {/* Left Side - Image */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "center",
          // Make the column wider to allow a larger image
          flex: { md: "0 0 48%", lg: "0 0 44%" },
          maxWidth: { md: "48%", lg: "44%" },
          px: 2,
          pl: { md: 1.5, lg: 2 },
          height: "100vh",
        }}
      >
        <Box
          component="img"
          src={mapImg}
          alt="Map"
          sx={{
            maxHeight: { md: "calc(92vh - 8vh)", lg: "calc(92vh - 8vh)" },
            width: "100%",
            height: "auto",
            maxWidth: "100%",
            my: "auto",
            ml: { md: 0.5, lg: 0.5 },
            borderRadius: 0,
            border: 0,
            display: "block",
            // Entrance animation
            opacity: mounted ? 1 : 0,
            transform: mounted ? "scale(1)" : "scale(1.02)",
            transition: "opacity 600ms ease, transform 800ms ease",
            willChange: "opacity, transform",
          }}
        />
      </Box>
      {/* Right Side - Login */}
      <Box
        sx={{
          // Take remaining width on desktop
          flex: { md: "1 0 52%", lg: "1 0 56%" },
          width: { md: "52%", lg: "56%" },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#fff",
          px: { xs: 3, md: 2 },
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 500,
            p: 6,
            boxShadow: "none",
            bgcolor: "transparent",
            // Subtle entrance animation
            opacity: mounted ? 1 : 0,
            transform: mounted ? "translateY(0)" : "translateY(8px)",
            transition: "opacity 500ms ease, transform 600ms ease",
            willChange: "opacity, transform",
          }}
        >
          {/* Logo block with shared width to align edges */}
          <Box sx={{ width: { xs: 220, md: 360 }, mx: 'auto', mb: 2 }}>
            {/* IntelliDrop Logo */}
            <Box
              component="img"
              src={idLogo}
              alt="IntelliDrop"
              sx={{ width: '100%', height: 'auto', display: 'block', mb: 1 }}
            />
            <Typography sx={{ fontWeight: 700, mb: 0.5, textAlign: 'center' }}>
              Powered By
            </Typography>
            <Box
              component="img"
              src={skyoviLogo}
              alt="Skyovi"
              sx={{
                width: '85%',
                height: 'auto',
                maxHeight: 38,
                objectFit: 'contain',
                display: 'block',
                mx: 'auto'
              }}
            />
          </Box>
          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <TextField
              label="Email"
              fullWidth
              sx={{ mb: 2 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={onEmailKeyDown}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              sx={{ mb: 3 }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              inputRef={passwordRef}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  color="primary"
                  size="small"
                />
              }
              label="Remember me"
              sx={{ mb: 2 }}
            />
            {error && (
              <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                background: "#90caf9",
                color: "#0d47a1",
                fontWeight: 600,
                fontSize: "1.1rem",
                mb: 6,
                "&:hover": { background: "#64b5f6" },
                borderRadius: 1,
                py: 1.8,
              }}
            >
              Login
            </Button>
          </Box>
          <Typography variant="body2" color="text.secondary" align="center">
            Copyright © 2025 | IntelliDrop
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default Login;
